<template>
  <v-tab-item :key="tabKey">
    <v-layout row wrap>
      <v-flex xs12>
        <v-list class="pa-1">
          <v-list-tile
            v-for="n in 4"
            :key="n"
            class="elevation-3 mt-3 mb-1"
            style="border-radius: 13px"
          >
            <v-list-tile-content>
              <v-list-tile-title class="my-3">
                <b>Autorización</b>
              </v-list-tile-title>
              <p class="expiration_text">Vigencia: 18 de julio de 2023</p>
            </v-list-tile-content>
            <v-list-tile-action class="expired" v-if="n % 2 === 0">
              <div class="thirdQR"></div>
              <span class="expired_text">Expirado</span>
            </v-list-tile-action>
          </v-list-tile>
        </v-list>
      </v-flex>
    </v-layout>
  </v-tab-item>
</template>
<script>
export default {
  props: {
    tabKey: {
      required: true,
      type: Number,
    },
  },
}
</script>
<style scoped>
.expiration_text {
  font-size: 14px;
  font-weight: 300;
}
.expired {
  position: relative;
}

.expired_text {
  position: absolute;
  bottom: -9px;
  z-index: 3;
  font-size: 10px;
  font-weight: 300;
}

::v-deep .v-list__tile {
  height: auto;
}
</style>
